import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskRescueServiceIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            d='M14.1284 20.2355C14.1284 21.5796 13.6781 22.4964 12.8634 22.8773C11.9971 23.1299 11.2417 22.9202 10.9556 22.8893C10.1477 22.5327 8.98416 20.9566 10.8103 19.5103C11.4695 18.9595 12.2103 18.3416 12.3125 16.4439C12.9192 16.9922 14.1284 18.3243 14.1284 20.2354L14.1284 20.2355ZM9.85466 1C11.6482 4.64452 10.5198 6.59967 10.5198 6.59967C10.5198 6.59967 9.12331 5.67413 8.58966 5.43177C9.01591 7.41263 8.76153 9.94354 7.20262 10.9558C0.932614 15.807 5.87919 20.7715 7.8738 21.9008C7.19661 21.0698 5.28704 17.9639 9.13279 15.5148C13.0765 12.9798 10.7553 9.82232 10.7553 9.82232C10.7553 9.82232 13.88 9.28864 16.7272 15.3542C17.8092 18.4573 16.6224 20.8705 16.1042 21.7274C18.5079 20.1462 19.8699 17.2405 19.8699 14.3453C19.8708 5.95427 11.4102 1.01373 9.85483 1.00009L9.85466 1Z'
        />
    ),
})

TaskRescueServiceIcon.displayName = 'TaskRescueServiceIcon'
